export default __webpack_public_path__ + "static/media/remote.d45783e7.png";